export default __webpack_public_path__ + "static/media/file-image.69aa6fb8.svg";